// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.04%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cal-page {
  min-height: 100vh;
  background: #faf7f2;
}

/* ── Entrance animations ── */
@keyframes calFadeUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes calFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.cal-header {
  animation: calFadeUp 0.55s ease both;
}

.cal-body {
  animation: calFadeUp 0.55s 0.15s ease both;
}

/* ── Header ── */
.cal-header {
  text-align: center;
  padding: 140px 24px 40px;
  background: linear-gradient(160deg, #3d1818 0%, #6b2323 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
}

.cal-header::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.cal-ornament {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #c9a96e, transparent);
  margin: 0 auto 24px;
}

.cal-title {
  font-family: 'Playfair Display', 'Georgia', serif;
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 700;
  color: #fff;
  margin: 0 0 16px;
  position: relative;
}

.cal-lead {
  font-size: 1.1rem;
  color: rgba(255,255,255,0.82);
  max-width: 540px;
  margin: 0 auto;
  line-height: 1.7;
  position: relative;
}

/* ── Body ── */
.cal-body {
  max-width: 820px;
  margin: 0 auto;
  padding: 48px 24px 64px;
}

/* ── Loading ── */
.cal-loading {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 80px 0;
}

.cal-loading-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #7b2323;
  animation: calDotPulse 1.2s ease-in-out infinite;
}

.cal-loading-dot:nth-child(2) { animation-delay: .2s; }
.cal-loading-dot:nth-child(3) { animation-delay: .4s; }

@keyframes calDotPulse {
  0%, 80%, 100% { transform: scale(0.7); opacity: 0.4; }
  40%           { transform: scale(1);   opacity: 1;   }
}

/* ── Empty state ── */
.cal-empty {
  text-align: center;
  padding: 64px 24px;
}

.cal-empty-icon {
  font-size: 3.5rem;
  margin-bottom: 20px;
}

.cal-empty-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.6rem;
  color: #3d1818;
  margin: 0 0 12px;
}

.cal-empty-text {
  color: #6b5050;
  line-height: 1.7;
  max-width: 480px;
  margin: 0 auto 32px;
}

/* ── Events list ── */
.cal-events-list {
  list-style: none;
  margin: 0 0 48px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cal-event-card {
  display: flex;
  align-items: center;
  gap: 24px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(61,24,24,.06);
  border: 1px solid rgba(61,24,24,.07);
  transition: box-shadow .2s, transform .2s;
}

.cal-event-card:hover {
  box-shadow: 0 4px 20px rgba(61,24,24,.12);
  transform: translateY(-1px);
}

.cal-event-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 68px;
  background: linear-gradient(160deg, #3d1818, #6b2323);
  border-radius: 10px;
  color: #fff;
  padding: 10px 8px;
  text-align: center;
  flex-shrink: 0;
}

.cal-event-day {
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1;
}

.cal-event-month {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: .08em;
  opacity: .85;
  margin-top: 2px;
}

.cal-event-year {
  font-size: 0.7rem;
  opacity: .7;
  margin-top: 1px;
}

.cal-event-body {
  flex: 1;
  min-width: 0;
}

.cal-event-name {
  font-family: 'Playfair Display', serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #3d1818;
  margin: 0 0 4px;
}

.cal-event-where {
  font-size: 0.92rem;
  color: #7b5050;
  margin: 0;
}

.cal-event-time {
  font-size: 0.85rem;
  color: #a07070;
  margin: 4px 0 0;
}

.cal-event-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity .2s, transform .2s;
  flex-shrink: 0;
}

.cal-event-link:hover { opacity: .85; transform: translateY(-1px); }

.cal-event-link--facebook  { background: #1877f2; color: #fff; }
.cal-event-link--instagram { background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888); color: #fff; }
.cal-event-link--website   { background: #f5f0e8; color: #3d1818; border: 1px solid rgba(61,24,24,.15); }

/* ── Follow section ── */
.cal-follow {
  text-align: center;
  margin-bottom: 56px;
  padding: 32px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(61,24,24,.07);
}

.cal-follow p {
  font-size: 1rem;
  color: #6b5050;
  margin: 0 0 16px;
}

.cal-social-links {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.cal-social-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: opacity .2s, transform .2s;
}

.cal-social-btn:hover { opacity: .85; transform: translateY(-1px); }

.cal-social-btn--fb { background: #1877f2; color: #fff; }
.cal-social-btn--ig { background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888); color: #fff; }

/* ── Cross-links ── */

@media (max-width: 600px) {
  .cal-event-card { flex-wrap: wrap; gap: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/CalendarPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mDAA8X;AAChY;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,gCAAgC,oBAAoB,EAAE;AACtD,gCAAgC,oBAAoB,EAAE;;AAEtD;EACE,gBAAgB,qBAAqB,EAAE,YAAY,EAAE;EACrD,gBAAgB,mBAAmB,IAAI,UAAU,IAAI;AACvD;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qDAAqD;EACrD,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,wBAAwB,YAAY,EAAE,2BAA2B,EAAE;;AAEnE,6BAA6B,mBAAmB,EAAE,WAAW,EAAE;AAC/D,6BAA6B,0EAA0E,EAAE,WAAW,EAAE;AACtH,6BAA6B,mBAAmB,EAAE,cAAc,EAAE,oCAAoC,EAAE;;AAExG,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA,wBAAwB,YAAY,EAAE,2BAA2B,EAAE;;AAEnE,sBAAsB,mBAAmB,EAAE,WAAW,EAAE;AACxD,sBAAsB,0EAA0E,EAAE,WAAW,EAAE;;AAE/G,sBAAsB;;AAEtB;EACE,kBAAkB,eAAe,EAAE,SAAS,EAAE;AAChD","sourcesContent":[".cal-page {\n  min-height: 100vh;\n  background: #faf7f2;\n}\n\n/* ── Entrance animations ── */\n@keyframes calFadeUp {\n  from { opacity: 0; transform: translateY(24px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes calFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.cal-header {\n  animation: calFadeUp 0.55s ease both;\n}\n\n.cal-body {\n  animation: calFadeUp 0.55s 0.15s ease both;\n}\n\n/* ── Header ── */\n.cal-header {\n  text-align: center;\n  padding: 140px 24px 40px;\n  background: linear-gradient(160deg, #3d1818 0%, #6b2323 100%);\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n}\n\n.cal-header::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.cal-ornament {\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(90deg, transparent, #c9a96e, transparent);\n  margin: 0 auto 24px;\n}\n\n.cal-title {\n  font-family: 'Playfair Display', 'Georgia', serif;\n  font-size: clamp(2rem, 5vw, 3rem);\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 16px;\n  position: relative;\n}\n\n.cal-lead {\n  font-size: 1.1rem;\n  color: rgba(255,255,255,0.82);\n  max-width: 540px;\n  margin: 0 auto;\n  line-height: 1.7;\n  position: relative;\n}\n\n/* ── Body ── */\n.cal-body {\n  max-width: 820px;\n  margin: 0 auto;\n  padding: 48px 24px 64px;\n}\n\n/* ── Loading ── */\n.cal-loading {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  padding: 80px 0;\n}\n\n.cal-loading-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #7b2323;\n  animation: calDotPulse 1.2s ease-in-out infinite;\n}\n\n.cal-loading-dot:nth-child(2) { animation-delay: .2s; }\n.cal-loading-dot:nth-child(3) { animation-delay: .4s; }\n\n@keyframes calDotPulse {\n  0%, 80%, 100% { transform: scale(0.7); opacity: 0.4; }\n  40%           { transform: scale(1);   opacity: 1;   }\n}\n\n/* ── Empty state ── */\n.cal-empty {\n  text-align: center;\n  padding: 64px 24px;\n}\n\n.cal-empty-icon {\n  font-size: 3.5rem;\n  margin-bottom: 20px;\n}\n\n.cal-empty-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.6rem;\n  color: #3d1818;\n  margin: 0 0 12px;\n}\n\n.cal-empty-text {\n  color: #6b5050;\n  line-height: 1.7;\n  max-width: 480px;\n  margin: 0 auto 32px;\n}\n\n/* ── Events list ── */\n.cal-events-list {\n  list-style: none;\n  margin: 0 0 48px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cal-event-card {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px 24px;\n  box-shadow: 0 2px 12px rgba(61,24,24,.06);\n  border: 1px solid rgba(61,24,24,.07);\n  transition: box-shadow .2s, transform .2s;\n}\n\n.cal-event-card:hover {\n  box-shadow: 0 4px 20px rgba(61,24,24,.12);\n  transform: translateY(-1px);\n}\n\n.cal-event-date {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 68px;\n  background: linear-gradient(160deg, #3d1818, #6b2323);\n  border-radius: 10px;\n  color: #fff;\n  padding: 10px 8px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.cal-event-day {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.8rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.cal-event-month {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n  opacity: .85;\n  margin-top: 2px;\n}\n\n.cal-event-year {\n  font-size: 0.7rem;\n  opacity: .7;\n  margin-top: 1px;\n}\n\n.cal-event-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.cal-event-name {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #3d1818;\n  margin: 0 0 4px;\n}\n\n.cal-event-where {\n  font-size: 0.92rem;\n  color: #7b5050;\n  margin: 0;\n}\n\n.cal-event-time {\n  font-size: 0.85rem;\n  color: #a07070;\n  margin: 4px 0 0;\n}\n\n.cal-event-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: opacity .2s, transform .2s;\n  flex-shrink: 0;\n}\n\n.cal-event-link:hover { opacity: .85; transform: translateY(-1px); }\n\n.cal-event-link--facebook  { background: #1877f2; color: #fff; }\n.cal-event-link--instagram { background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888); color: #fff; }\n.cal-event-link--website   { background: #f5f0e8; color: #3d1818; border: 1px solid rgba(61,24,24,.15); }\n\n/* ── Follow section ── */\n.cal-follow {\n  text-align: center;\n  margin-bottom: 56px;\n  padding: 32px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid rgba(61,24,24,.07);\n}\n\n.cal-follow p {\n  font-size: 1rem;\n  color: #6b5050;\n  margin: 0 0 16px;\n}\n\n.cal-social-links {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.cal-social-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: opacity .2s, transform .2s;\n}\n\n.cal-social-btn:hover { opacity: .85; transform: translateY(-1px); }\n\n.cal-social-btn--fb { background: #1877f2; color: #fff; }\n.cal-social-btn--ig { background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888); color: #fff; }\n\n/* ── Cross-links ── */\n\n@media (max-width: 600px) {\n  .cal-event-card { flex-wrap: wrap; gap: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
